import { zip as observableZip, zip } from 'rxjs';

import { DOCUMENT } from "@angular/common";
import { HttpErrorResponse } from "@angular/common/http";
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { WIM_Locale_Container, WIM_LOCALE_ID } from 'app/app.module';
import { CredentialsCache } from 'common/auth/services/service.credentials';
import { filter, map, mergeMap } from 'rxjs/operators';
import { AppSettingsProvider } from "../../../app/global/services/app.settings.provider";
import { BrowserAttributes } from "../../../common/browser/detect.browser";
import { ClientContextService } from "../../../common/client.context/services/client.context.service";
import { ISystemConfiguration } from "../../../common/configuration";
import { SystemConfigurationPreLoginService } from "../../../common/configuration/services/system.configuration.pre.login.service";
import { TimezoneService } from "../../../common/datetime/services/timezone.service";
import { AssetProxy } from "../../../common/http/services/assets.proxy";
import { ProductLabelingState } from "../../../common/labeling/product.labeling.state";
import { LogCat, LogManager } from "../../../common/log";
import { RtlEnum } from "../../../common/rtl/interfaces/rtl.enum";
import { RtlService } from "../../../common/rtl/services/rtl.service";
import { TranslateLanguage } from "../../../common/translate/interfaces/translate.language";
import { TranslateConfigService } from "../../../common/translate/services/translate.config.service";
import { Themes, ThemeService } from "../../../common/ui/services/theme.changer";
import { IVersionDetails } from "../../../common/version.details/interfaces/version.details";
import { VersionDetailsService } from "../../../common/version.details/services/version.details.service";
import { IClientContext } from "../../user.context/interfaces/Iclient.context";
import { LoginService } from "../services/login.service";

declare var __ris_global_vars__:any;

export enum ShowFormState {
	Loading,
	Show,
	DontShow
}

/**
 * component for login to the system
 */
@UntilDestroy()
@Component({
	selector: 'cp-login',
	providers: [],
	templateUrl: './login.html',
	styleUrls: ["./login.scss"],
	encapsulation: ViewEncapsulation.Emulated,
})
export class LoginComponent implements OnInit, OnDestroy {
	readonly emptyDomain = "none";

	public statusFlag: string;
	public status: string;
	public autoLogin: boolean;
	public showForm: boolean;
	public showLogin: ShowFormState;
	public translateLoaded: boolean;
	public dir: string = null;
	public domain: string;
	public domainForCache:string;
	public showChangePassword: boolean = false;
	public showAbout: boolean = false;
	public headerTitle: string = 'Workflow Information Management ';

	public licenseValidation;
	public timeZoneValidation;
	public browserValidation;
	public serverTime: string;

	public resources = {
		imgs: {
			// philips: null,
			// cautionSymbol: null,
			// consultSymbol: null,
			philipsLight: "./assets/login/philips.light.png",
			philipsDemo: "./assets/login/philips.light.png",
			philipsDark: "./assets/login/philips.dark.png",
			main: "./assets/login/loginBGblue.jpg",
			cautionSymbolLight: "./assets/login/caution-light.png",
			cautionSymbolDark: "./assets/login/caution-dark.png",
			consultSymbolight: "./assets/login/consult-light.png",
			consultSymbolDark: "./assets/login/consult-dark.png"
		}
	};

	public buildDate: string;
	public releaseVersion: string;
	public commercialVersion: string;
	public warningMessage: string;
	public warningMessageEnabled: string;
	public isUnreleasedDevice: boolean;
	public isNonMedicalDevice: boolean;

	public userNameParam: string;
	// public passParam: string;
	// public shs: string;
	public directoryServer: string;
	public loginSuccessUrl: string;
	public ignoreTimeZone: boolean;
	public disableLoginButton: boolean;
	public userPasswordPattern: number;
	public passwordMinLength: number;
	public lockTimeInMinutes: number;
	public maxNumberOfOTPDeliveryTimeFrameMinutes: number;

	public embeddedLogin;

	public theme=Themes;

	private clientContext: IClientContext;
	private userNameQueryParam;
	private passQueryParam;
	private extActivationQueryParam;
	private shsQueryParam;
	private showShsLoginError;

	private disclaimerWindow:Window;

	private internalParams = ["user", "pass", "theme", "redirect","shs","sso_external","showShsLoginError"];
	private requestedTheme: string;
	private languageKeyParam: number;
	private missingKedoCodeErr=
		'User default language is not determined in the system. It may be caused by missing kendoCode property for the required language.';
	
	private model: any;

	public readonly copyrightYear = 2025;

	public showVerificationCodeDialog: boolean;
	public showTOTPInitializationDialog: boolean;
	public showSessionExpiredMessage: boolean;

	public statusParam: string;

	constructor(@Inject(DOCUMENT) private doc: Document,
				private route: ActivatedRoute,
				private browserAtts: BrowserAttributes,
				private authService: LoginService,
				private assetProxy: AssetProxy,
				private router: Router,
				private themeService: ThemeService,
				private cd: ChangeDetectorRef,
				private rtlService: RtlService,
				private translateConfigService: TranslateConfigService,
				private clientContextService: ClientContextService,
				private versionDetailsService: VersionDetailsService,
				private appSettings:AppSettingsProvider,
				private preLoginConfigService: SystemConfigurationPreLoginService,
				private timezoneService: TimezoneService,
				private credentialsContainer:CredentialsCache,
				@Inject(WIM_LOCALE_ID) private wimLocaleId:WIM_Locale_Container) {
	}

	ngOnInit() {
		this.showLogin = ShowFormState.Loading;
		this.disableLoginButton = false;
		LogManager.debug(LogCat.AppShell.Login, "Login Controller launched");
		this.authService.clearLoginInfo();

		let queryParams = this.route.snapshot.queryParams;

		this.userNameQueryParam = queryParams["user"];
		this.passQueryParam = queryParams["pass"];
		this.extActivationQueryParam = queryParams["external_activation"];
		this.shsQueryParam = queryParams["sso_external"] ?? queryParams["shs"];
		this.showShsLoginError = "true"===queryParams["showShsLoginError"];
		this.embeddedLogin = queryParams["embeddedLogin"]==="true";

		let rsna_rad = queryParams["rsnaRad"];

		if (queryParams["redirect"]){
			// we have "/" at the end of the URL. It is redundant and confuses the routing
			let lastIndexOfSlash=queryParams["redirect"].lastIndexOf("/");
			this.loginSuccessUrl = lastIndexOfSlash===queryParams["redirect"].length-1?
				queryParams["redirect"].substr(0,lastIndexOfSlash):queryParams["redirect"];
		}else{
			this.loginSuccessUrl = "/app";
		}
		this.statusFlag = "normal";

		this.autoLogin = (this.userNameQueryParam && this.passQueryParam) || this.shsQueryParam;

		if (undefined !== rsna_rad){
			this.doc.body.classList.add("rsna-rad");
		}

		let formsDraftMode = queryParams["draftForms"];
		if ('true'===formsDraftMode){
			this.appSettings.draftMode=true;
		}

		this.requestedTheme = queryParams["theme"];

		this.languageKeyParam = +queryParams["language"];

		this.ignoreTimeZone = queryParams["ignore_timezone"] ? queryParams["ignore_timezone"] === 'true' : false;

		if (this.requestedTheme) {
			LogManager.info(LogCat.AppShell.Window, "will set theme to " + this.requestedTheme);

			let t = Themes[this.requestedTheme];
			this.themeService.setTheme(t);
			this.themeService.setToHostedContext();
		}
		// switch (this.themeService.currentTheme) {
		// 	case Themes.dark:{
		// 		this.resources.imgs.philips=this.resources.imgs.philipsDark;
		// 		this.resources.imgs.cautionSymbol = this.resources.imgs.cautionSymbolDark;
		// 		this.resources.imgs.consultSymbol =  this.resources.imgs.consultSymbolDark;
		// 		break;
		// 	}
		// 	case Themes.dynamic:{
		// 		this.resources.imgs.philips = this.resources.imgs.philipsLight;
		// 		this.resources.imgs.cautionSymbol = this.resources.imgs.cautionSymbolLight;
		// 		this.resources.imgs.consultSymbol = this.resources.imgs.consultSymbolight;
		// 		break;
		// 	}
		// 	case Themes.light:{
		// 		this.resources.imgs.philips=this.resources.imgs.philipsLight;
		// 		this.resources.imgs.cautionSymbol = this.resources.imgs.cautionSymbolLight;
		// 		this.resources.imgs.consultSymbol = this.resources.imgs.consultSymbolight;
		// 		break;
		// 	}
		// }

		this.browserAtts.detectBrowser();

		this.browserValidation = !__ris_global_vars__.browser || (this.browserAtts.browser_name in __ris_global_vars__.browser && (
			__ris_global_vars__.browser[this.browserAtts.browser_name] === null ||
			__ris_global_vars__.browser[this.browserAtts.browser_name] <= this.browserAtts.browserVersion
		));

		if (!this.autoLogin || !this.browserValidation) {
			this.loadTranslateData();
		}
		if (!this.autoLogin){
			this.versionDetailsService.load().pipe(filter(x => x != null), untilDestroyed(this)).subscribe(() => {
				let versionDetails: IVersionDetails = this.versionDetailsService.getVersionDetails();
				this.buildDate = versionDetails.buildDate.toString();
				this.commercialVersion = versionDetails.commercialVersion;
				this.releaseVersion = this.getProductReleaseVersion(versionDetails.commercialVersion);


				this.setProductLabelingStateFields(versionDetails);

				this.cd.markForCheck();
			});
		}

		if (!this.browserValidation) {

			LogManager.error(LogCat.AppShell.Login, "Browser validation failed",
				this.browserAtts.browser_name, this.browserAtts.browserVersion, __ris_global_vars__.browser);

		}

		let clientContextObservable = this.clientContextService.load().pipe(filter(x => x != null));
		let offsetObservable = this.timezoneService.loadServerOffsetFromUTC();
		zip(clientContextObservable, offsetObservable).pipe(untilDestroyed(this)).subscribe(() => {
			this.clientContext = this.clientContextService.getCachedClientContext();
			this.licenseValidation = this.clientContext.serverLicenseValid;
			this.finalizeLoginValidations();
		});

		this.preLoginConfigService.getPreLoginSystemConfiguration().pipe(untilDestroyed(this))
			.subscribe((configuration: ISystemConfiguration) => {
				this.userPasswordPattern = +configuration.UserPasswordPattern.value;
				this.passwordMinLength = +configuration.PasswordMinLength.value;
				this.lockTimeInMinutes = +configuration.LockExpirationTimeInMinutes.value;
				this.maxNumberOfOTPDeliveryTimeFrameMinutes = +configuration.MaxNumberOfOTPDeliveryTimeFrameMinutes.value;
				this.warningMessage = configuration.LoginScreenSecurityWarninigText.value;
				this.warningMessageEnabled = configuration.LoginScreenSecurityWarninigEnabled.value;
				this.cd.markForCheck();
			});

		this.cd.markForCheck();
	}

	ngOnDestroy() {
		LogManager.debug(LogCat.AppShell.Login, "ngOnDestroy");
	}

	public openDisclaimer(){
		const disclaimerHTMLURL=__ris_global_vars__.version?__ris_global_vars__.version+"/disclaimer/disclaimer.html":""+"/disclaimer/disclaimer.html";
		let openOptions="width=800,menubar=no,toolbar=no,height="+screen.height;

		if (this.disclaimerWindow && !this.disclaimerWindow.closed){
			this.disclaimerWindow.focus();
		}else{
			this.disclaimerWindow = window.open(disclaimerHTMLURL,"_blank",openOptions);
		}

	}

	public login(model) {
		if (this.isValid(model.value)) {
			this.model = model;
			this.doLogin(model.value.userName, model.value.password, false);
		} else {
			this.disableLoginButton = false;
		}
	}

	public isValid(model): boolean {
		if (!model.userName) {
			this.statusFlag = 'invalid';
			this.status = 'UserNameMustNotBeEmpty';
			return false;
		} else if (!model.password) {
			this.statusFlag = 'invalid';
			this.status = 'PasswordMustNotBeEmpty';
			return false;
		}
		return true;
	}

	public setDirectory(domain: string) {
		this.domainForCache=domain;
		this.domain = domain.toLowerCase() === this.emptyDomain ? null : domain;
	}

	public onPasswordChangeClick() {
		if (this.userPasswordPattern !== undefined) {
			this.showChangePassword = true;
		} else {
			LogManager.info(LogCat.AppShell.Login, "PreLogin System Configuration not loaded yet");
		}
	}

	private finalizeLoginValidations() {
		this.timeZoneValidation = this.timezoneService.getStoredOffsetDifference() === 0;

		if (!this.timeZoneValidation) {
			this.serverTime = this.timezoneService.getServerTime().toLocaleString();

			LogManager.error(LogCat.AppShell.Login, "Timezone validation failed",
				this.timezoneService.getServerOffsetFromUTC(), this.timezoneService.getLocalOffsetFromUTC());
		}

		this.showForm = ((this.ignoreTimeZone || this.timeZoneValidation) && this.licenseValidation && (this.dir !== null));

		if (this.dir !== null) {
			this.showLogin = (this.ignoreTimeZone || this.timeZoneValidation) && this.licenseValidation ?
							ShowFormState.Show : ShowFormState.DontShow;
		}

		this.cd.markForCheck();

		if (this.autoLogin && (this.ignoreTimeZone || this.timeZoneValidation) && this.licenseValidation) {
			if (this.userNameQueryParam && this.passQueryParam) {
				this.doLogin(this.userNameQueryParam, this.passQueryParam, this.extActivationQueryParam);
			} else if (this.shsQueryParam) {
				// the shs token was decoded by angular routing. we would like to encode it before sending to service
				let shsEncoded = encodeURIComponent(this.shsQueryParam);
				this.doLoginShs(shsEncoded, this.showShsLoginError);
			}
		} else if (this.autoLogin){
			// there was an error and we need translations
			this.loadTranslateData();
		} else if (this.userNameQueryParam) {
			// not autologin, but username and directory server auto fill
			let directorySplitPosition = this.userNameQueryParam.indexOf('@');
			this.userNameParam = directorySplitPosition === -1 ? this.userNameQueryParam :
				this.userNameQueryParam.substring(0, this.userNameQueryParam.indexOf('@'));
			this.directoryServer = directorySplitPosition === -1 ? undefined :
				this.userNameQueryParam.substring(this.userNameQueryParam.indexOf('@') + 1);
		}
	}

	private loadTranslateData() {
		// At this step (before login) user preferences are not retrieved and the user language settings are not available yet.
		// So an appropriate application direction will be set according to the browser language settings.
		// After login the application direction will be set according to the user language preferences.
		this.translateConfigService.loadDataObservable(false).pipe(untilDestroyed(this)).subscribe(() => {
			let browserLang: TranslateLanguage = this.translateConfigService.navigatorLanguage;
			this.dir = browserLang.rightToLeft ? RtlEnum[RtlEnum.rtl] : RtlEnum[RtlEnum.ltr];
			this.rtlService.setDir(browserLang.rightToLeft ? RtlEnum.rtl : RtlEnum.ltr);

			this.translateLoaded = true;

			this.showForm = ((this.ignoreTimeZone || this.timeZoneValidation) && this.licenseValidation && (this.dir !== null));

			this.showLogin = (this.ignoreTimeZone || this.timeZoneValidation) && this.licenseValidation ?
				ShowFormState.Show : ShowFormState.DontShow;

			this.cd.markForCheck();
		});
	}

	private doLoginShs(shs: string,showLoginError:boolean) {
		this.markLoginStart();
		let tokenPromise = this.authService.setShsCredentials(shs);
		tokenPromise.pipe(untilDestroyed(this)).subscribe(() => {
			LogManager.debug(LogCat.AppShell.Login, "login passed - before languages retrieval");
			this.onLoginSuccess();
		}, error => {
			if (showLoginError) {
				LogManager.error(LogCat.AppShell.Login, "SHS login failed", error);
				this.autoLogin = false;
				this.statusFlag = 'invalid';
				this.status = "TokenInvalid";
				this.loadTranslateData();
			} else {
				this.doc.head.innerHTML = "";
				this.doc.body.innerHTML = "";
			}
		});
	}

	private markLoginStart() {
		this.status = "AuthenticatingPleaseWait";
		this.statusFlag = "inprog";
		this.statusParam = null;
	}

	private doLogin(userName: string, password: string, external_activation: boolean) {
		this.markLoginStart();
		// LogManager.debug(LogCat.AppShell.Login, "login started");
		if (this.domain) {
			userName = this.domain.concat("\\").concat(userName);
		}
		let tokenPromise = this.authService.setCredentials(userName, password, external_activation);

		// TODO - handle failed login
		tokenPromise.pipe(untilDestroyed(this)).subscribe(() => {
			LogManager.debug(LogCat.AppShell.Login, "login passed - before languages retrieval");
			//the translation support is currently limited.
			// the requirement is to allow the user to select his preferred language upon login.
			// since this is still not properly defined in UX terms, it is not implemented at this point.
			this.onLoginSuccess();

		}, (e: HttpErrorResponse) => {
			this.handleLoginReturnCode(e);
			this.cd.markForCheck();
		});
	}

	public codeVerified(e: any) {
		if (!e) {
			this.onLoginSuccess();
		} else if (e.error.error && e.error.error === "606") { //MFA required or Initialize TOTP
			this.showTOTPInitializationDialog = true;
		}
	}

	public clearCredentials() {
		this.model?.reset({
			userName: null,
			password: null
		});
		this.userNameQueryParam = this.passQueryParam = null;
		this.disableLoginButton = false;
	}

	private handleLoginReturnCode(e) {
		if (e.error.error && (e.error.error === "604" || e.error.error === "606")) { //MFA required or Initialize TOTP
			this.clearPassword();
			this.statusFlag = 'waitingVerificationCode';
			this.disableLoginButton = true;
			if (e.error.error === "604") {
				this.showVerificationCodeDialog = true;
			} else if (e.error.error === "606") {
				this.showTOTPInitializationDialog = true;
			}
		} else {
			this.statusFlag = 'invalid';
			this.disableLoginButton = false;
			this.status = e.error.error_description
				? this.authService.handleServerException(e.error.error_description)
				: this.authService.handleServerException(e.statusText);
			if (e.error.error) {
				if (e.error.error === "423") {
					this.statusParam = this.lockTimeInMinutes.toString();
				} else if (e.error.error === "607") {
					this.statusParam = this.maxNumberOfOTPDeliveryTimeFrameMinutes.toString();
				}
			}	
			LogManager.info(LogCat.AppShell.Login, "failed to login", e);
		}
	}

	private clearPassword() {
		this.model.reset({
			userName: this.model.value.userName,
			password: null
		});
		this.passQueryParam = null;
	}
	
	private onLoginSuccess() {
		if (this.embeddedLogin) {
			this.postMessage(this.credentialsContainer.mToken);
			return;
		}

		LogManager.debug(LogCat.AppShell.Login, "subscriptions received on client and login may route");
		this.status = "SuccessfulAuthentication";
		this.statusFlag = "inprog";

		if (this.domainForCache && this.domainForCache !== ""){
			localStorage["lastLoginDirectoryDomain"]=this.domainForCache;
		}

		if (!this.browserAtts.isNode()) {
			if (this.doc.activeElement && this.doc.activeElement.nodeName === "INPUT") {
				(<HTMLInputElement>this.doc.activeElement).blur();
			}
		}
		//let url = this.loginSuccessUrl;
		let newQueryParams = Object.assign({}, this.route.snapshot.queryParams);
		this.internalParams.forEach(p => {
			if (newQueryParams[p]) {
				delete newQueryParams[p];
			}
		});

		let newQueryParamsStr = "";
		Object.keys(newQueryParams).forEach(currParam => {
			newQueryParamsStr = newQueryParamsStr.concat("&" + currParam + "=" + newQueryParams[currParam]);
		});

		if (!this.requestedTheme){
			this.authService.getUserTheme().pipe(untilDestroyed(this)).subscribe((theme: string) => {
				this.requestedTheme = theme.toLowerCase();
				this.selectLanguage(newQueryParamsStr);
			});
		} else{
			this.selectLanguage(newQueryParamsStr);
		}	
	}

	private selectLanguage(queryParamsStr: string){
		//LogManager.debug(LogCat.AppShell.Login, "login passed - before languages retrieval");
		//the tranlation support is currently limited.
		// the requirement is to allow the user to select his preferred language upon login.
		// since this is still not properly defined in UX terms, it is not implemented at this point.
		//this.translateConfigService.setByUserLanguage().subscribe(() => {
		//	LogManager.debug(LogCat.AppShell.Login, "languages available");
		if (!this.languageKeyParam) {
			observableZip(this.translateConfigService.getLanguages(true),
				this.authService.getUserLanguage()).pipe(
				map(userAndLanguages => {
					this.translateConfigService.languages = userAndLanguages[0];
					let userLangKey = userAndLanguages[1];
					let lang: TranslateLanguage = userAndLanguages[0].find(l => l.languageKey === userLangKey);
					if (!lang) {
						LogManager.fatal(LogCat.AppShell.Login, this.missingKedoCodeErr);
						this.status = "User Language Misconfigured";
						this.statusFlag = "invalidNoTranslate";
					}
					//__ris_global_vars__.kendoLocale = lang.kendoCode;
					this.wimLocaleId.setLocale(lang.kendoCode);
					return userLangKey;
				}), mergeMap((x) =>
					this.rtlService.setDirByLangKey(x)),).pipe(untilDestroyed(this)).subscribe((shellDir: RtlEnum) => {
				this.navigateToSuccessUrl(queryParamsStr);
			});
		} else {
			this.translateConfigService.getLanguages(true).pipe(
			map(languages => {
				this.translateConfigService.languages = languages;
				let userLangKey = this.languageKeyParam;
				let lang: TranslateLanguage = languages.find(l => l.languageKey === userLangKey);
				if (!lang) {
					LogManager.fatal(LogCat.AppShell.Login, this.missingKedoCodeErr);
					this.status = "User Language Misconfigured";
					this.statusFlag = "invalidNoTranslate";
				}
				this.translateConfigService.forceSpecificLanguage = lang;
				//__ris_global_vars__.kendoLocale = lang.kendoCode;
				this.wimLocaleId.setLocale(lang.kendoCode);
				return userLangKey;
			}), mergeMap((x) =>
					this.rtlService.setDirByLangKey(x)),).pipe(untilDestroyed(this)).subscribe((shellDir: RtlEnum) => {
				this.navigateToSuccessUrl(queryParamsStr);
			});
		}
	}

	private navigateToSuccessUrl(queryParamsStr: string){
		this.router.navigateByUrl(this.loginSuccessUrl + "?" + queryParamsStr)
			.then(x => {
				this.themeService.setTheme(Themes[this.requestedTheme]);
				LogManager.debug(LogCat.AppShell.Login, "routing finished with " + x);
			})
			.catch(err => {
					LogManager.error(LogCat.AppShell.Login, "error routing,", err);

					throw err;
				}
			);
	}

	private setProductLabelingStateFields(versionDetails: IVersionDetails){
		this.setHeaderTitle(versionDetails);
		this.isUnreleasedDevice = (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice);
		this.isNonMedicalDevice = (versionDetails.productLabelingState !== ProductLabelingState.ReleasedMedicalDevice);
	}

	private setHeaderTitle(versionDetails: IVersionDetails) {
		let titleText = this.headerTitle;
		titleText += versionDetails.commercialVersion.split('.')[0];
		if (versionDetails.productLabelingState === ProductLabelingState.UnreleasedDevice) {
			titleText += " (WIP)";
		}
		this.headerTitle = titleText;
	}

	private getProductReleaseVersion(commercialVersion: string): string {
		const versionParts : string[] = commercialVersion.split('.');
		if (versionParts.length > 1){
			return `${versionParts[0]}.${versionParts[1]}`;
		}
		return commercialVersion;
	}

	private postMessage(msg: any) {
		if (window.location.host === 'localhost:8082') {
			window.parent.postMessage(msg, '*');
		} else {
			window.parent.postMessage(msg);
		}
	}
}
